import React from "react";
import { Button } from "@/components/ui/button";
import { UsageTracker } from "@/lib/services/usage-tracker";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase";

export function AuthDebug() {
  const { user } = useAuth();

  const testUsageTracking = async () => {
    if (!user) {
      return;
    }


    try {
      // Test contract review tracking
      await UsageTracker.trackContractReview(user.id, "test_analysis", "pdf");

      // Test legal research tracking
      await UsageTracker.trackLegalResearch(
        user.id,
        "test_search",
        "Colombia",
        "labor"
      );

      // Check if data was inserted
      const { data: usage, error } = await supabase
        .from("feature_usage")
        .select("*")
        .eq("user_id", user.id)
        .order("used_at", { ascending: false })
        .limit(5);

    } catch (error) {
      console.error("Error testing usage tracking:", error);
    }
  };

  const checkFeatureUsageTable = async () => {
    try {
      const { data, error } = await supabase
        .from("feature_usage")
        .select("*")
        .limit(10);


      if (data) {
        data.forEach((record, index) => {
        });
      }
    } catch (error) {
      console.error("Error checking feature_usage table:", error);
    }
  };

  if (!user) {
    return <div>No user logged in</div>;
  }

  return (
    <div className="p-4 border rounded-lg bg-gray-50">
      <h3 className="text-lg font-semibold mb-4">Usage Tracking Debug</h3>
      <div className="space-y-2">
        <Button onClick={testUsageTracking} variant="outline">
          Test Usage Tracking
        </Button>
        <Button onClick={checkFeatureUsageTable} variant="outline">
          Check Feature Usage Table
        </Button>
        <div className="text-sm text-gray-600">User ID: {user.id}</div>
      </div>
    </div>
  );
}
